import { render, staticRenderFns } from "./GruposImportarTab.vue?vue&type=template&id=90bb85d6&scoped=true"
import script from "./GruposImportarTab.vue?vue&type=script&lang=js"
export * from "./GruposImportarTab.vue?vue&type=script&lang=js"
import style0 from "./GruposImportarTab.vue?vue&type=style&index=0&id=90bb85d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90bb85d6",
  null
  
)

export default component.exports